import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
const solid = {
    green: 'bg-ep-greenSoft text-ep-green2',
    blue: 'bg-blue-100 text-blue-800',
    amber: 'bg-amber-100 text-amber-800',
    red: 'bg-red-100 text-red-800',
    gray: 'bg-gray-100 text-gray-700',
    purple: 'bg-purple-100 text-purple-800',
    teal: 'bg-teal-100 text-teal-800',
    pink: 'bg-pink-100 text-pink-800',
};
const outlined = {
    green: 'border border-ep-green/30 text-ep-green2 bg-transparent',
    blue: 'border border-blue-300 text-blue-700 bg-transparent',
    amber: 'border border-amber-300 text-amber-700 bg-transparent',
    red: 'border border-red-300 text-red-700 bg-transparent',
    gray: 'border border-gray-300 text-gray-600 bg-transparent',
    purple: 'border border-purple-300 text-purple-700 bg-transparent',
    teal: 'border border-teal-300 text-teal-700 bg-transparent',
    pink: 'border border-pink-300 text-pink-700 bg-transparent',
};
const dots = {
    green: 'bg-ep-green', blue: 'bg-blue-500', amber: 'bg-amber-500',
    red: 'bg-red-500', gray: 'bg-gray-400', purple: 'bg-purple-500',
    teal: 'bg-teal-500', pink: 'bg-pink-500',
};
export function Badge({ children, variant = 'gray', size = 'md', dot, outline, className }) {
    return (_jsxs("span", { className: cn('inline-flex items-center gap-1.5 font-medium rounded-full', size === 'sm' ? 'text-[10px] px-1.5 py-px' : 'text-xs px-2 py-0.5', outline ? outlined[variant] : solid[variant], className), children: [dot && _jsx("span", { className: cn('w-1.5 h-1.5 rounded-full shrink-0', dots[variant]) }), children] }));
}
